import * as React from 'react';
import classNames from 'classnames';
import styles from '../styles/FieldSearch.module.scss';
import {isPopup} from '../../../_shared/GWTBridge/invoke/netForm';
import {PriorityIcon, Icon} from '@priority-software/priority-style-react';

export const HoveringZoomButton = ({
    onZoom,
    icon = PriorityIcon.zoom,
    tooltip = '',
    elementRef = null,
    borderStyle = {}
}) => {
    return (
        <div
            className={classNames(styles.zoomBtn, styles.fieldBtn, {
                [styles.popupDropdownStyle]: isPopup()
            })}
            title={tooltip}
            ref={elementRef}
            style={borderStyle}
        >
            <Icon
                icon={icon}
                iconColor="secondary-500"
                onClick={onZoom}
                componentClasses={styles.hoveringZoomButton}
            />
        </div>
    );
};
